import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../../core/services/security.service';
import { UserFunctions } from '../../core/enums/security-functions.enum';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  template: `
    <!-- <button kendoButton (click)="abrirModal()">Abrir modal"</button> -->

    <!-- <app-modal /> -->
  `
})
export class HomeComponent implements OnInit {
  private router = inject(Router);
  private securityService = inject(SecurityService);

  // modal = inject(ModalService);

  ngOnInit() {
    const funciones = this.securityService.getUserFunctions() ?? [];
    const tieneAccesoLegajos = [
      UserFunctions.Legos_Visualizar,
      UserFunctions.Legos_Editar,
      UserFunctions.Legos_Homologar
    ].some(fn => funciones.includes(fn));

    if (tieneAccesoLegajos) {
      this.router.navigate(['/legajos']);
    }
  }

  // async abrirModalGrilla() {
  //   const resultado = await this.modal.openComponent(
  //     'Seleccionar usuario',
  //     RolesConsultaComponent,
  //     { filtro: 'admin' }
  //   );
  //   console.log('Resultado modal:', resultado);
  // }
}
